module.exports = __webpack_public_path__ + "static/Hmed-zidi-184dd30015777ee5925cb68d787c5c1f.jpg";